<template>
  <div id="sdg-slider" ref="element" :class="isOverlay ? 'chat--sdg' : ''">
    <div class="arrow-sdg arrow-prev swiper-button-prev">
      <img src="../assets/arrow-sdg-prev.svg" />
    </div>
    <div class="arrow-sdg arrow-next swiper-button-next">
      <img src="../assets/arrow-sdg-next.svg" />
    </div>
    <div class="swiper-container" >
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#e91c2e'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché tante persone che hanno a malapena lo stretto necessario per sopravvivere lasciano spesso la propria casa e il proprio paese per cercare lavoro e condizioni di vita migliori?"
                      :
                      "Why do so many people who have the bare minimum to survive often leave their homes and countries in search for work and better life conditions?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-1.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-1.png" />
                  <img src="../assets/Icone-SDGs/icon-1.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Sconfiggere la povertà"
                      :
                      "No poverty"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Dobbiamo eliminare la povertà per garantire a tutti l’accesso a cibo sano, di qualità e in quantità sufficienti per nutrire individui e società."
                      :
                      "We must prevent poverty to grant everyone access to healthy, quality food, and in sufficient quantities to feed individuals and societies."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#d29e29'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché la start up di Julia intende fornire alle aree colpite dalla fame risorse che consentano alla popolazione di coltivare cibo?"
                      :
                      "Why does Julia’s start-up aim at providing hunger-afflicted areas with resources that enable the population to grow food?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-2.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-2.png" />
                  <img src="../assets/Icone-SDGs/icon-2.png" />
                </div>
                <h4>
                  {{
                    $i18n.locale == 'it' ?
                    "Sconfiggere la fame"
                    :
                    "Zero hunger"
                  }}
                </h4>
                <p>
                  {{
                    $i18n.locale == 'it' ?
                    "Oltre 690 milioni di persone soffrono la fame. L’agricoltura e la gestione sostenibile delle risorse sono essenziali per garantire cibo a tutti."
                    :
                    "Over 690 million people suffer from hunger. Agriculture and sustainable management of resources are essential to guarantee food for all."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#279a47'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché è fondamentale che i bambini siano nutriti e abbiano accesso a cibo e acqua pulita?"
                      :
                      "Why is it crucial for children to be nourished and have access to food and clean water?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-3.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-3.png" />
                  <img src="../assets/Icone-SDGs/icon-3.png" />
                </div>
                <h4>
                  {{
                    $i18n.locale == 'it' ?
                    "Salute e benessere"
                    :
                    "Good health and well-being"
                  }}
                </h4>
                <p>
                  {{
                    $i18n.locale == 'it' ?
                    "Adottare un’alimentazione sana sin dall’infanzia previene le malattie non trasmissibili, che sono le principali cause di morte a livello globale (oltre il 70%)."
                    :
                    "Adopting healthy diets from childhood prevents non-communicable diseases, leading causes of death worldwide (over 70%)."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#c01f33'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché entrambi i genitori di Ekon si destreggiano fra due lavori per permettergli di frequentare la scuola superiore e andare all’università?"
                      :
                      "Why is Ekon’s mother and father juggling two jobs each so that he will be able to attend high school and go to university?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-4.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-4.png" />
                  <img src="../assets/Icone-SDGs/icon-4.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Istruzione di qualità"
                      :
                      "Quality education"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Garantire un accesso equo a tutti i livelli di istruzione contribuisce alla sicurezza alimentare. I bambini ben nutriti ottengono migliori risultati scolastici."
                      :
                      "Ensuring fair access to all levels of education contributes to food security. Well-fed kids do better in school."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#ee422b'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Jamila è l’amministratrice delegata di un marchio di caffè e pensa che molte più donne dovrebbero lavorare in posizioni di potere come lei. Perché?"
                      :
                      "Jamila is the CEO of a coffee brand and thinks many more women should be working in positions of power like her. Why?"
                    }}
                    </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-5.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-5.png" />
                  <img src="../assets/Icone-SDGs/icon-5.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Parità di genere"
                      :
                      "Gender equality"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Le donne rappresentano il 40% dei lavoratori agricoli. Dove le donne hanno accesso a risorse eque, la produzione agricola e la sicurezza alimentare aumentano."
                      :
                      "Women represent 40% of the agricultural workforce. Where women have access to equal resources, agricultural production and food security increases."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#09acd7'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché si stanno costruendo condutture dell’acqua in un piccolo villaggio dell’Africa sub-sahariana?"
                      :
                      "Why are water pipes being built in a small Sub-Saharan African village?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-6.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-6.png" />
                  <img src="../assets/Icone-SDGs/icon-6.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Acqua pulita e servizi igienico-sanitari"
                      :
                      "Clean water and sanitation"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "L’accesso all’acqua pulita è essenziale per preparare e consumare il cibo. Inoltre, è necessario un utilizzo più sostenibile dell’acqua in agricoltura (che consuma il 70% dell’acqua dolce prelevata)."
                      :
                      "Access to clean water is essential for preparing/consuming food. A more sustainable use of water in agriculture is also necessary (it consumes 70% of the freshwater withdrawn)."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#fcb516'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Alessandra si approvvigiona di energia elettrica dai pannelli solari installati sul tetto della sua azienda agricola?"
                      :
                      "Why does Alessandra source electric energy from solar panels installed on her farm’s roof?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-7.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-7.png" />
                  <img src="../assets/Icone-SDGs/icon-7.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Energia pulita e accessibile"
                      :
                      "Affordable and clean energy"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "I sistemi alimentari dipendono dai combustibili fossili, che sono causa di inquinamento. Le fonti di energia rinnovabile permettono di produrre cibo in modo più sostenibile."
                      :
                      "Food systems depend on fossil fuels, responsible for pollution. Renewable energy sources allow you to produce food in a more sustainable way."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#8c1b37'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché è importante che Marisa lavori nel settore agroalimentare e fornisca ai propri figli i mezzi per cercare lavori più remunerativi?"
                      :
                      "Why is it important Marisa works in the agri-food sector and provides her children with the means to look for even better paying jobs?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-8.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-8.png" />
                  <img src="../assets/Icone-SDGs/icon-8.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Lavoro dignitoso e crescita economica"
                      :
                      "Decent work and economic growth"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Il settore agroalimentare offre opportunità di lavoro lungo la filiera, nello sviluppo del settore e nei servizi di assistenza."
                      :
                      "The agri-food sector offers job opportunities along the supply chain, in the development of the sector and in support services."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#f26e25'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Xinhui e Fang sono contenti che ci sia una nuova linea di trasporto pubblico che li può portare in una città nei pressi della loro fattoria dove possono vendere i loro prodotti?"
                      :
                      "Why are Xinhui and Fang happy there is a new public transport line that can take them to a city near their farm where they can sell their produce?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-9.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-9.png" />
                  <img src="../assets/Icone-SDGs/icon-9.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Imprese, innovazione e infrastrutture"
                      :
                      "Industry, innovation and infrastructure"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Migliorare le infrastrutture, l’accesso ai mercati e i collegamenti con le città aiuta l’economia locale, migliora l’alimentazione della popolazione e rallenta l’esodo dalle campagne."
                      :
                      "Improving infrastructure, access to markets, and connecting with cities helps the local economy, improves the nutrition of the population, and slows the migration from the countryside."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#e01582'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Mathias lavora per un’organizzazione senza scopo di lucro che si propone di fornire cibo e assistenza sanitaria a chi non se li può permettere?"
                      :
                      "Why does Mathias work for a non-profit organisation that aims to provide food and health care to those who can’t afford them?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-10.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-10.png" />
                  <img src="../assets/Icone-SDGs/icon-10.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Ridurre le disuguaglianze"
                      :
                      "Reduced inequalities"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Le persone più povere e vulnerabili soffrono spesso di insicurezza alimentare e dispongono di minore accesso alla terra, alle risorse e ai servizi necessari alla produzione."
                      :
                      "Poorer and more vulnerable people often suffer from food insecurity, they have less access to land, resources and services needed to produce."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#f89a26'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché la sindaca di una città la sta dotando di orti urbani?"
                      :
                      "Why is a city mayor implementing her city with urban vegetable gardens?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-11.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-11.png" />
                  <img src="../assets/Icone-SDGs/icon-11.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Città e comunità sostenibili"
                      :
                      "Sustainable cities and communities"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Il 55% delle persone vive in città ed entro il 2050 questa percentuale raggiungerà il 68%. Elaborare politiche migliori è essenziale per sviluppare città sostenibili in grado di offrire agli abitanti l’accesso a cibo sano, sostenibile e di alta qualità."
                      :
                      "55% of people live in cities, by 2050 it will reach 68%. Rolling out better policies is essential in building sustainable cities that can provide inhabitants access to healthy, sustainable, and high-quality food."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#cd8b2b'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Carmen sta molto attenta a non comprare più del necessario e a non sprecare niente di quanto ha acquistato per la sua famiglia?"
                      :
                      "Why is Carmen very careful to not over-buy or waste anything she shopped for her family?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-12.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-12.png" />
                  <img src="../assets/Icone-SDGs/icon-12.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Consumo e produzione responsabili"
                      :
                      "Responsible consumption and production"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Dobbiamo mettere fine alla perdita di cibo nel viaggio dalla produzione al carrello della spesa e allo spreco alimentare nei negozi e a casa. Un terzo del cibo prodotto nel mondo va perduto o sprecato."
                      :
                      "We must put an end to food being lost during its journey from production to shopping cart or wasted in stores and at home. One third of the food produced in the world is lost or wasted."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#48783d'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Alberto fa la spesa cercando di comprare localmente quanto più cibo possibile?"
                      :
                      "Why does Alberto do his grocery shopping trying to source locally as much food possible?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-13.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-13.png" />
                  <img src="../assets/Icone-SDGs/icon-13.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Lotta contro il cambiamento climatico"
                      :
                      "Climate action"
                  }}
                  </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Le nostre scelte alimentari quotidiane possono contribuire ad aiutare la lotta contro il cambiamento climatico. Dai campi a tavola, l’industria alimentare genera fino al 37% delle emissioni di gas a effetto serra. È tempo di ridurre questo inquinamento e risanare l’ambiente."
                      :
                      "Our daily food choices can contribute to help climate action. The food system from farm to fork is responsible for up to 37% of greenhouse gas emissions. Limiting this pollution will help us keep the planet cool and stop climate change."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#027dba'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Sarah compra solo pesce pescato in maniera sostenibile e partecipa alle pulizie delle spiagge con i suoi amici quando va al mare?"
                      :
                      "Why will Sarah buy fish that is only caught sustainably and participates in beach cleanups with her friends whenever she goes to the seaside?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-14.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-14.png" />
                  <img src="../assets/Icone-SDGs/icon-14.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Vita sott'acqua"
                      :
                      "Life below water"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Dobbiamo prenderci cura di ogni forma di vita, anche sott’acqua. Mettendo fine all’inquinamento, all’acidificazione e all’impoverimento degli oceani possiamo preservare il sostentamento di milioni di persone che dipendono dalla pesca"
                      :
                      "We must take care of all life, even below water. By putting an end to pollution, acidification, and overfishing of the oceans, we can save the livelihood of millions that depend on fishing."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#3fae49'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Thomas ha piantato frutteti nella sua proprietà anziché procurarsi la frutta altrove?"
                      :
                      "Why did Thomas plant orchards in his property instead of sourcing fruit elsewhere?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-15.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-15.png" />
                  <img src="../assets/Icone-SDGs/icon-15.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Vita sulla terra"
                      :
                      "Life on land"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Le foreste ricoprono il 31% della superficie terrestre e ospitano l’80% della biodiversità terrestre globale e 300 milioni di persone, mentre 1,6 miliardi di persone ne dipendono per il proprio sostentamento. Per proteggerle, dobbiamo ripensare l’uso e le pratiche dei terreni agricoli."
                      :
                      "Forests cover 31% of the earth's surface and are home to 80% of the world's terrestrial biodiversity. Three hundred million people worldwide live in forests and 1.6 billion depend on them for their livelihoods. We must protect them at all costs by rethinking agricultural land use and practices."
                  }}
                  </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#025689'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché Soraya e la sua famiglia sono costrette a lasciare il loro paese martoriato dalla guerra?"
                      :
                      "Why are Soraya and her family forced to leave their war-torn country?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-16.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-16.png" />
                  <img src="../assets/Icone-SDGs/icon-16.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Pace, giustizia e istituzioni solide"
                      :
                      "Peace, justice and strong instituitions"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "L’intensificarsi dei conflitti provoca l’aumento della fame nel mondo. La sicurezza alimentare è indispensabile per la sicurezza dei paesi."
                      :
                      "The intensification of conflicts causes increased hunger in the world. Food security is vital for the safety of countries."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="card--sdg">
            <div class="card--inner">
              <div class="card--front" :style="{backgroundColor: '#1a3668'}">
                <div class="card--front-text">
                  <p>
                    {{
                      $i18n.locale == 'it' ?
                      "Perché dobbiamo unire le forze se vogliamo che avvenga il cambiamento?"
                      :
                      "Why do we have to join forces if we want change to happen?"
                    }}
                  </p>
                  <div class="cta--why" @click="flipCard">
                    <p>{{$i18n.locale == 'it' ? "Scopri perché" : "Find out why"}}</p>
                  </div>
                </div>
                <img src="../assets/front-sdg/SDG-17.svg" />
              </div>
              <div class="card--back">
                <div class="sdg-icon-wrap">
                  <img src="../assets/Numeri-SDGs/tag-icon-17.png" />
                  <img src="../assets/Icone-SDGs/icon-17.png" />
                </div>
                <h4>
                  {{
                      $i18n.locale == 'it' ?
                      "Partnerships per gli obiettivi"
                      :
                      "Partnerships for the goals"
                  }}
                </h4>
                <p>
                  {{
                      $i18n.locale == 'it' ?
                      "Per ogni dollaro investito nell’alimentazione c’è un rendimento di 16 dollari in crescita economica. La collaborazione è necessaria per accelerare la transizione a sistemi alimentari più sani e sostenibili."
                      :
                      "For every $1 invested in nutrition, there is a return of $16 in economic growth. Collaboration is needed to accelerate the transition to healthier and more sustainable food systems."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {gsap, TimelineMax, Power2, Linear} from 'gsap'
import Swiper from 'swiper'
import 'swiper/css/swiper.css';

export default {
  name: 'SdgSlider',
  components:{
  },
  props: ['isOverlay'],
  data(){
    return {
      time: ''
    }
  },
  methods:{
    initSwiper(){
      
      this.swiperEL = new Swiper('#sdg-slider .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        observer: true, 
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        // Navigation arrows
        navigation: {
          nextEl: '#sdg-slider .swiper-button-next',
          prevEl: '#sdg-slider .swiper-button-prev',
        },
        breakpoints:{
          768:{
            slidesPerView:  2, 
            spaceBetween: 20,
          },
          1120: {
            slidesPerView: this.isOverlay ? 2 : 3, 
            spaceBetween: 20,
          }
        },
      });

      setTimeout( this.transitioIn, 500)
    },
    transitioIn(){
      if(this.isOverlay) this.$store.dispatch('triggerScrollWindow', this.$refs.element.offsetHeight - 75);
      gsap.to('#sdg-slider', {duration: .75, opacity: 1, ease: Power2.easeInOut})
    },
    flipCard(event){
      var holder = event.currentTarget.parentNode.parentNode.parentNode;
      holder.classList.add('flipped')
    }
  },
  mounted(){
    this.initSwiper()
  },
  beforeDestroy(){
    this.swiperEL = null
  },
  computed:{
    ...mapState({
      chatStep: state => state.chatStep
    })
  }
  
}
</script>

<style lang="scss">
  #sdg-slider{
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    opacity: 0;
    .swiper-container{
      position: relative;
      top: 0;
      height: auto;
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
      .swiper-wrapper{
        position: relative;
        margin: 0 auto;
        .swiper-slide{
          position: relative;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          height: auto;
          align-self: stretch;
          .card--sdg{
            position: relative;
            align-self: stretch;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            width: 100%;
          }
          .card--inner{
            position: relative;
            text-align: center;
            transition: transform 0.75s;
            transform-style: preserve-3d;
            box-sizing: content-box;
            align-self: stretch;
            height: 100%;
          }
          .card--front{
            position: absolute;
            top: 0;
            left: 0;
            opacity: 1;
            transition: opacity .5s ;
          }
          .card--front-text{
            position: relative;
            z-index: 2;
            height: 100%;
            display: flex;
            align-self: stretch;
            flex-direction: column;
            justify-content: space-between;
          }
          .card--front-text p {
            color: #fff;
            padding: 20px;
            font-size: 24px;
            line-height: 32px;
          }
          .card--front-text .cta--why {
            border: 1px solid #000;
            background-color: #fff;
            align-self: center;
            padding: 16px 20px;
            margin-bottom: 32px;
            border-radius: 5px;
            box-shadow: 5px 5px 0px 0px #1d1d1b;
          }
          .card--front-text .cta--why p {
            padding: 0;
            font-size: 18px;
            line-height: 32px;
            color: #000;
            display: inline-block;
          }
          .card--front img{
            position: absolute;
            z-index: 1;
            bottom: 0;
            left: 0;
            width: 100%;
          }
          .card--front, .card--back {
            -webkit-backface-visibility: hidden; /* Safari */
            backface-visibility: hidden;
            overflow: hidden;
            align-self: stretch;
            border: 1px solid #000;
            overflow: hidden;
            border-radius: 20px;
            height: calc(100% - 2px);
          }
          .card--back { 
            position: relative;
            z-index: 3;
            background-color: #E2E7EC;
            color: #000;
            transform: rotateY(180deg);
          }
          .card--back h4,
          .card--back p {
            padding: 0 20px 20px;
          }
          .card--back p {
            line-height: 24px;
          }
          .card--inner.flipped  {
            transform: rotateY(180deg);
            .card--front {
              opacity: 0;
            }
          }
          .sdg-icon-wrap{
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-around;
            img{
              margin: 0 auto;
              &:nth-child(1){
                width: 100px;
                @media screen and(max-width: 860px) {
                  width: 60px;
                }
              }
              &:nth-child(2){
                max-width: 100%;
              }
            }
          }
          h4{
            font-size: 20px;
            line-height: 22px;
            margin: 10px auto;
            font-family: roc-grotesk, sans-serif;
            font-weight: 500;
            font-style: normal;
          }
        }
      }
    }
    &.chat--sdg{
      .swiper-container{
        overflow: visible;
      }
    }
    .arrow-sdg{
      position: absolute;
      cursor: pointer;
      width: 40px;
      img{
        display: block;
        width: 100%;
      }
      &::after{
        content: '';
      }
      &.arrow-next{
        right: -50px;
        @media screen and(max-width: 767px) {
          right: 10px;
        }
      }
      &.arrow-prev{
        left: -50px;
        @media screen and(max-width: 767px) {
          left: 10px;
        }
      }
    }
    @media screen and(max-width: 767px) {
      overflow: hidden;
      width: 100vw;
      &.chat--sdg{
        margin-left: -40px;
        margin-right: 0;
        margin-top: 20px;
      }
      padding-left: 0;
      padding-right: 0;
      .swiper-container{
        width: 70%;
      }
    }
  }
</style>